import React from 'react';

import Context from './context';

export const useContext = () => React.useContext(Context);
